import PropTypes from 'prop-types';
import React from 'react';

import Chevron, { DIRECTIONS } from 'components/Chevron';
import { SenaryParagraphHeading } from 'components/Headings';
import Theme from 'styles/theme';

const Breadcrumb = ({ label, onClick, ...otherProps }) => (
  <button onClick={onClick} className="Breadcrumb" {...otherProps}>
    <div className="Breadcrumb__chevron">
      <Chevron direction={DIRECTIONS.LEFT} />
    </div>

    <SenaryParagraphHeading>{label}</SenaryParagraphHeading>
    <style jsx>
      {`
        .Breadcrumb {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          border: 0;
          outline: 0;
          padding: ${Theme.get('spacing') * 3}px ${Theme.get('spacing') * 6}px;
          cursor: pointer;
          border-bottom: solid 1px ${Theme.get('colors-black-20')};
          position: relative;
          background-color: ${Theme.get('colors-grey')};
        }

        .Breadcrumb__chevron {
          position: absolute;
          top: 50%;
          left: ${Theme.get('spacing') * 6}px;
          transform: translateY(-50%);
        }

        .Breadcrumb.focused {
          outline: 2px solid ${Theme.get('colors-black')};
        }
      `}
    </style>
  </button>
);

Breadcrumb.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

Breadcrumb.defaultProps = {};

export default Breadcrumb;
